import { ContactInfo } from '@/types'

export const contactInfo: ContactInfo = {
  phone: '0540 003 12 13',
  whatsapp: '0540 003 12 13',
  email: 'info@ardicveteriner.com',
  address: 'Fuar Alanı Kavşağı Dış Kapı:2, Batıkent Mahallesi Çardaklıkaya Bulvarı, C İç Kapı: No:22, 63000 Karaköprü/Şanlıurfa',
  workingHours: {
    weekdays: '09:00 - 19:00',
    weekend: '09:00 - 17:00',
    emergency: '7/24 Acil Hizmet'
  },
  socialMedia: {
    instagram: 'https://instagram.com/ardicveteriner'
  }
}
